import React from 'react';
import { Table } from '@bedrock/components';
import { CheckCircleFilled, EllipsisCircleFilled, CheckHeavy, ClockFilled } from '@bedrock/icons-react';
import classNames from 'classnames/bind';
import styles from './index.less';
import Operator from '../Operator';
import moment from 'moment';


export interface ProgressProps {
  id: number;
  mapNodes: any[];
  remindState: any;
  notify_operate_user_list?: any[];
  journal_type?: string;
  className?: string;
}
const cx = classNames.bind(styles);

function ProcessNode(props: ProgressProps) {
  const {
    id,
    mapNodes,
    remindState,
    journal_type,
    notify_operate_user_list,
    className,
  } = props;


  const columns = [
    {
      title: '',
      width: 36,
      className: cx('icon-cell'),
      dataIndex: 'node',
      render: (v, r, i) => {
        if (r?.key === "unknown") {
          return <div className={cx('icon-box')}><EllipsisCircleFilled size={16} className={cx('closureIcon')} /></div>
        }
        const index = mapNodes?.findIndex(item => item?.is_current)
        if (i === mapNodes.length - 1) {
          return <div className={cx('icon-box')}>
            <CheckCircleFilled size={16} className={cx('closureIcon', {
              'current': r?.is_current,
            })} />
          </div>
        }
        if (r?.is_current) {
          return <div className={cx('icon-box')}>
            <ClockFilled className={cx('closureIcon')} size={16} style={{ color: 'var(--primary-1)' }} />
          </div>
        }
        return (
          <div className={cx('icon-box')}>
            <div className={cx('rock-icon')} />
            {i > index ? <div className='padding-icon'></div> :
              <CheckHeavy
                className={cx('closureIcon')}
                size={16}
                style={{
                  color: 'var(--primary-1)',
                  background: 'var(--primary-5)',
                  borderRadius: '8px',
                }}
              />
            }
          </div>
        )
      }
    },
    {
      dataIndex: 'state_name',
      title: '节点',
      className: cx('cell-node'),
      width: 145,
      align: 'left',
      render: (v, r, i) => {
        if (r?.key === "unknown") {
          return <div className={cx('conventionalTitle')}>后续节点待定</div>;
        }
        if (i === mapNodes.length - 1) {
          return <div className={cx(r?.is_current ? "conventionalTitle" : 'ashTitle')}>{v}</div>;
        } else {
          return <div className={cx('conventionalTitle')}>{v}</div>;
        }
      },
    },
    {
      dataIndex: 'node_type',
      title: '操作',
      align: 'left',
      width: 80,
      render: (v, r, i) => {
        const index = mapNodes?.findIndex(item => item?.is_current)
        if (i < index) {
          return <div className={cx('successTest')}>已通过</div>;
        } else if (i === mapNodes?.length - 1) {
          return <div className={cx('successTest')}>{r?.operate_name}</div>;
        } else if (i === index) {
          return <div className={cx('warnTest')}>处理中</div>;
        } else {
          return <div className={cx('conventionalTest')}>待处理</div>;
        }
      },
    },
    {
      dataIndex: 'operate_time',
      title: '操作时间',
      align: 'left',
      width: 180,
      render: (v, r, i) => {
        return <div className={cx('conventionalTest')}>{v}</div>;
      },
    },
    {
      dataIndex: 'operate_user',
      title: '操作人',
      align: 'left',
      // minWidth: 198,
      width: 198,
      render(v, r: any) {
        const value = Array.isArray(v) ? v : [v];
        const useList = r?.is_current ? [...notify_operate_user_list] : value.filter(Boolean)
        return (
          <Operator journal_type={journal_type} useList={[...useList]} row={r} remindState={remindState} id={id} />
        )
      },
    },
    {
      dataIndex: 'elapsed_time',
      title: '操作时长',
      className: cx('elapsed_time-cell'),
      align: 'left',
      width: 90,
      fixed: 'right',
      render: (v, r, i) => {
        let duration = moment.duration(v, 'seconds');
        let days = Math.floor(duration.asDays());
        let hours = Math.floor(duration.hours());
        let minutes = Math.floor(duration.minutes());
        let seconds = Math.floor(duration.seconds());
        let value = "";
        if (days > 0) {
          value = `${days}天`
        } else if (hours > 0) {
          value = `${hours}小时`
        } else if (minutes > 0) {
          value = `${minutes}分钟`
        } else if (seconds > 0) {
          value = `${seconds}秒`
        } else {
          value = ""
        }
        return <div className={cx('conventionalTest')}>{value}</div>;
      },
    },
  ];
  return <Table className={cx('process-node-table', className)} columns={columns as any} data={mapNodes} border={false} />;
}
export default ProcessNode;
